/**
 * License Error Page
 * Displayed when the backend /api/access/login returns route = 'license-error'.
 * Shows a copyable Tenant ID so the user can share it with their admin
 * to get a license provisioned.
 */

import { getCurrentTenantId } from '../services/licenseService';
import { LicenseNotFoundCard } from '../components/license/LicenseNotFoundCard';
import { StatusPrimaryButton, StatusSecondaryButton } from '../components/layout/StatusScreen';

export default function LicenseError() {
    const tenantId = getCurrentTenantId() || '';

    return (
        <LicenseNotFoundCard
            tenantId={tenantId}
            actions={
                <>
                    <StatusSecondaryButton onClick={() => window.location.reload()}>
                        🔄 Refresh
                    </StatusSecondaryButton>
                    <StatusPrimaryButton onClick={() => { window.location.href = '/'; }}>
                        ← Back to Home
                    </StatusPrimaryButton>
                </>
            }
        />
    );
}
